// TODO: From App New
<template>
  <div class="row">
    <SaleWizardNavigation
      :sale-id="$route.params.id"
      :sale-data="$store.state.saleV2.detailData"
    />

    <div class="col">
      <b-card>
        <FormBuilder
          label="Sale"
          update
          :data="$store.state.saleV2.detailData"
          :fields="fields"
          :loading-detail="$store.state.saleV2.loadingDetail"
          :loading-submit="$store.state.saleV2.loadingSubmit"
          @load="loadData"
          @submit="submitData"
          @reset="resetData"
        />
      </b-card>
    </div>
  </div>
</template>

<script>
import FormBuilder from '@/layouts/components/v2/FormBuilder.vue'
import SaleWizardNavigation from '@/components/sale/SaleWizardNavigation.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/sale'

export default {
  components: {
    BCard,
    FormBuilder,
    SaleWizardNavigation,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('saleV2/getDetail', id)
    },
    submitData(id, data, callback) {
      this.$store.dispatch('saleV2/update', { id, data })
        .then(() => {
          if (typeof callback === 'function') callback()
        })
        .catch(err => callback(err))
    },
    resetData() {
      return this.$store.commit('saleV2/SET_DETAIL_DATA', undefined)
    },
  },
}
</script>

<style scoped>

</style>
